import { memo, useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzChip } from '../../components';
import KeyStats from './KeyStats';
import SupportResistance from '../Analysis/SupportResistance';
import SimpleMovingAverages from '../Analysis/SimpleMovingAverages';
import DeliveryQuantityBuildup from './DeliveryQuantityBuildup';
import MarketPulse from './MarketPulse';
import AllExchangesMarketDepth from '../AllExchangesMarketDepth';
import { useDispatch, useSelector } from 'react-redux';
import { WATCHLIST_GRID_INDEX, SUPPORT_RESISTANCE_VIEW, MARKET_SEGMENT_ID, BEST5_INDEX, TL_INDEX, SCRIP_INSTRUMENTS } from '../../utils/global_variables';

import { calculateSupportRestistanceValues, convertDateToSeconds, getChangeInRs } from '../../utils/global_functions';
import { GetContractDetails } from '../../redux/actions/marketOverview';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import { useWFHMessages } from '../../hooks';
import MarketMovement from './MarketMovement';


const Overview = ({ setIsMarketMovement, expandScripOverviewModel }) => {
  const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);
  const selectedArrRowData = useSelector(state => state.marketOverview.selectedArrRowData);
  const securityDetails = useSelector(state => state?.marketOverview?.securityDetails);
  const objContractCodeInfo = useSelector(state => state.marketOverview.objContractCodeInfo);
  const holdingsScrips = useSelector(state => state?.holdings?.holdingsScrips);
  //Vaibhav Singh: 09-11-23 : BT-109089 : Variables for  : Start
  const { dontMissData } = useSelector(state => state.dontMiss);
  const [dontMissDataChip, setDontMissDataChip] = useState([]);
  const [currentHolding, setCurrentHolding] = useState([]);
  const [holdingInfo, setHoldingInfo] = useState([]);
  const [arrScripInformation, setArrScripInformation] = useState([]);
  //Vaibhav Singh: 09-11-23 : BT-109089 : Variables for  : End
  //KAMESH RANE :Support & Resistance 
  const dispatch = useDispatch();
  const [supportResistance, setSupportResistance] = useState({});
  //Vaibhav Singh: BT-109089: 26-10-2023: Updated APIs call for support and resistance with securitydetails and contractinfo api updatedfro code upadtion: Start
  useEffect(() => {
    if (scripOverviewData.length !== 0) {
      if (scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_CASH || scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_CASH || scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.MSX_CASH || scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.OFS_IPO_BONDS) {
        const marketSupportResistanceData = securityDetails?.pivot?.length ? { PrevClose: securityDetails?.pivot[0]?.PrevClose, PrevHigh: securityDetails?.pivot[0]?.PrevHigh, PrevLow: securityDetails?.pivot[0]?.PrevLow, PrevOpen: securityDetails?.pivot[0]?.PrevOpen } : {};
        // {/* Vaibhav Singh: 06-12-23: BT-109089: Added page Flag: Start */}
        const resitancePivotObj = calculateSupportRestistanceValues(marketSupportResistanceData, 'Classic', '(H+L+C)/3', scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], true);
        // {/* Vaibhav Singh: 06-12-23: BT-109089: Added page Flag: End */}
        setSupportResistance(resitancePivotObj);
      } else {
        // Vaibhav Singh: 01-12-23:BT-109089: Contract Details API payload changed : Start
        dispatch(GetContractDetails({ mktSegmentId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID], token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], expDate: convertDateToSeconds(scripOverviewData[WATCHLIST_GRID_INDEX.EXPIRYDATE]), symbol: scripOverviewData[WATCHLIST_GRID_INDEX.SYMBOL], instName: scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT], strkPrice: (scripOverviewData[WATCHLIST_GRID_INDEX.STRIKEPRICE]) === '' ? '-1' : (parseFloat(scripOverviewData[WATCHLIST_GRID_INDEX?.STRIKEPRICE]) * scripOverviewData[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR]), optType: scripOverviewData[WATCHLIST_GRID_INDEX?.OPTIONTYPE] }));
        // Vaibhav Singh: 01-12-23:BT-109089: Contract Details API payload changed : End
      }
    } else { }
  }, [dispatch, scripOverviewData, securityDetails]);

  const handleArrGridRowData = (segmentId, token, e) => {
    const detail = [...e.detail];
    if (segmentId === detail[BEST5_INDEX.SEGMENT_ID] && token === detail[BEST5_INDEX.TOKEN]) {
      //By HiralK : 06-09-2023 : For Price optimization - Start
      detail[BEST5_INDEX.LAST_TRADE_PRICE] = (detail[BEST5_INDEX.LAST_TRADE_PRICE]);//.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
      //detail[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = detail[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] / scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
      //By HiralK : 06-09-2023 : For Price optimization - End
      setArrScripInformation(detail);
    }
  };
  useWFHMessages('bestfive', (e) => {
    handleArrGridRowData(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], e);
  });
  useEffect(() => {
    if (scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
      const objLastTickData = dispatch(getWfhTouchlineLastTick());
      const arrLastTickScripData = objLastTickData[scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
      if (arrLastTickScripData?.length > 0) {
        arrLastTickScripData[BEST5_INDEX.LAST_TRADE_PRICE] = (parseFloat(arrLastTickScripData[BEST5_INDEX.LAST_TRADE_PRICE]));
        arrLastTickScripData[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = (arrLastTickScripData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]); // Hari: 29-07-2023 show LTP change in recommendations scrip overview
        setArrScripInformation([...arrLastTickScripData]);
      } else { }
    } else { }
  }, [dispatch, scripOverviewData]);
  useEffect(() => {
    if (holdingsScrips?.length || Object?.keys(holdingsScrips ? holdingsScrips : [])?.length) {
      let currHoldings = [];
      if (holdingsScrips?.status) {
        //Vaibhav Singh:16-12-23: BT-107055: ISIN code added fixed: Start
        holdingsScrips?.result?.forEach((item) => {
          if (item['ISIN'] === scripOverviewData[WATCHLIST_GRID_INDEX.ISIN_CODE] && scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
            currHoldings.push(item);
          }
        });
      }
      else {
        holdingsScrips.forEach((item) => {
          if (item['ISIN'] === scripOverviewData[WATCHLIST_GRID_INDEX.ISIN_CODE] && scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
            currHoldings.push(item);
          }
        });
        //Vaibhav Singh:16-12-23: BT-107055: ISIN code added fixed: End
      }
      setCurrentHolding(currHoldings);
    }
  }, [holdingsScrips, scripOverviewData]);
  useEffect(() => {
    if (currentHolding?.length) {
      if (currentHolding[0]?.nBuyAvgPrice) {
        let arrNetChangePNL = getChangeInRs((arrScripInformation[BEST5_INDEX.LAST_TRADE_PRICE] * currentHolding[0]['TOTALFREEQUANTITY']).toFixed(2), (parseFloat(currentHolding[0]?.nBuyAvgPrice) * parseInt(currentHolding[0]?.TOTALFREEQUANTITY)).toFixed(2), 2, false, 'uptrend');
        setHoldingInfo(arrNetChangePNL);
      }
      //Vaibhav Singh : BT-109089: 15-11-223: Added Else handling in Holding : Start
    } else {
      setHoldingInfo([]);
    }
    //Vaibhav Singh : BT-109089: 15-11-223: Added Else handling in Holding : End
  }, [arrScripInformation]);

  useEffect(() => {
    if (currentHolding?.length) {
      if (currentHolding[0]?.nBuyAvgPrice) {
        let arrNetChangePNL = getChangeInRs((arrScripInformation[BEST5_INDEX.LAST_TRADE_PRICE] * currentHolding[0]['TOTALFREEQUANTITY']).toFixed(2), (parseFloat(currentHolding[0]?.nBuyAvgPrice) * parseInt(currentHolding[0]?.TOTALFREEQUANTITY)).toFixed(2), 2, false, 'uptrend');
        setHoldingInfo(arrNetChangePNL);
      }
      //Vaibhav Singh : BT-109089: 15-11-223: Added Else handling in Holding : Start
    } else {
      setHoldingInfo([]);
    }
    //Vaibhav Singh : BT-109089: 15-11-223: Added Else handling in Holding : End
  }, [arrScripInformation]);

  useEffect(() => {
    if (scripOverviewData.length !== 0 && objContractCodeInfo) {
      const marketSupportResistanceData = Object.keys(objContractCodeInfo?.highlowclose)?.length ? { PrevClose: objContractCodeInfo?.highlowclose?.PrevClose, PrevHigh: objContractCodeInfo?.highlowclose?.PrevHigh, PrevLow: objContractCodeInfo?.highlowclose?.PrevLow, PrevOpen: objContractCodeInfo?.highlowclose?.PrevOpen } : {};
      // {/* Vaibhav Singh: 06-12-23: BT-109089: Added page Flag: Start */}
      const resitancePivotObj = calculateSupportRestistanceValues(marketSupportResistanceData, 'Classic', '(H+L+C)/3', scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], true);
      // {/* Vaibhav Singh: 06-12-23: BT-109089: Added page Flag: End */}
      setSupportResistance(resitancePivotObj);
    }
    else {
      if (!securityDetails?.pivot?.length && scripOverviewData?.length) {
        // {/* Vaibhav Singh: 06-12-23: BT-109089: Added page Flag: Start */}
        const resitancePivotObj = calculateSupportRestistanceValues({ PrevClose: '0.00', PrevHigh: '0.00', PrevLow: '0.00', PrevOpen: '0.00' }, 'Classic', '(H+L+C)/3', scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], true);
        // {/* Vaibhav Singh: 06-12-23: BT-109089: Added page Flag: End */}
        setSupportResistance(resitancePivotObj);
      }
    }
  }, [objContractCodeInfo, scripOverviewData]);
  //Vaibhav Singh: 09-11-23 : BT-109089 : Added DontmissLogic to be open from everywhere updated logic for support data: Start
  useEffect(() => {
    const objDontMiss = dontMissData.find(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
    if (objDontMiss !== undefined) {
      setDontMissDataChip(objDontMiss[WATCHLIST_GRID_INDEX.DONT_MISS]);
    } else if (Array.isArray(selectedArrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]) && selectedArrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0) {
      setDontMissDataChip(selectedArrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]);
    }
    else {
      setDontMissDataChip([]);
    }
  }, [dontMissData, scripOverviewData]);
  //Vaibhav Singh: 09-11-23 : BT-109089 : Added DontmissLogic to be open from everywhere: End



  return (
    <Container fluid className='p-0' data-testid="market-overview-container">

      {((scripOverviewData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 && scripOverviewData[WATCHLIST_GRID_INDEX.DONT_MISS] !== '0') || dontMissDataChip && dontMissDataChip?.length || currentHolding?.length || holdingInfo?.length) ?
        <div className='scripoverview-highlighter' data-testid="market-overview-highlighter-section">
          <Row className='g-0 justify-content-between align-items-center'>
            <Col md={currentHolding?.length || holdingInfo?.length ? 'auto' : 12}>
              <div className='scripoverview-highlighter-wrap'>
                {((scripOverviewData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 && scripOverviewData[WATCHLIST_GRID_INDEX.DONT_MISS] !== '0') || dontMissDataChip && dontMissDataChip?.length) ?
                  <>
                    <div className='d-flex align-items-center' data-testid="market-overview-dont-miss-section">
                      <div className='icon-16 icon-dontmiss icon-yellow' data-testid="market-overview-dont-miss-icon"></div>
                      <div className='font-medium font-size2 color-text ms-1 p-t-3' data-testid="market-overview-dont-miss-label">Don't Miss</div>
                    </div>

                    {dontMissDataChip && dontMissDataChip?.length ? dontMissDataChip?.length && dontMissDataChip?.map((item, index) =>
                      <div className='d-flex align-items-center ms-3 pe-2' key={index} data-testid={`market-overview-dont-miss-chip-${index}`}>
                        <div className='chips-wrap'>
                          <BzChip className={`chips default-chip ${item?.color?.includes('negative') ? 'negative-chip' : (item?.color?.includes('positive') ? 'positive-chip' : '')}`} data-testid={`market-overview-dont-miss-event-${index}-chip`}>{item?.event}</BzChip>    {/* Bhagyashri P [30-11-2023] : BT-109089 Scrip Overview - class changes */}
                        </div>
                        <div className='font-regular highlighter-text color-text ms-1' data-testid={`market-overview-dont-miss-desc-${index}-label`}>{item?.Desc}</div>
                      </div>
                    ) : scripOverviewData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length && scripOverviewData[WATCHLIST_GRID_INDEX.DONT_MISS]?.map((item, index) =>
                      <div className='d-flex align-items-center ms-3 pe-2' key={index} data-testid={`market-overview-dont-miss-chip-${index}`}>
                        <div className='chips-wrap'>
                          <BzChip className={`chips default-chip ${item?.color?.includes('negative') ? 'negative-chip' : (item?.color?.includes('positive') ? 'positive-chip' : '')}`} data-testid={`market-overview-dont-miss-event-${index}-chip`}>{item?.event}</BzChip>    {/* Bhagyashri P [30-11-2023] : BT-109089 Scrip Overview - class changes */}
                        </div>
                        <div className='font-regular highlighter-text color-text ms-1' data-testid={`market-overview-dont-miss-desc-${index}-label`}>{item?.Desc}</div>
                      </div>
                    )}
                  </>
                  : null
                }
              </div>
            </Col>
            <Col md={(scripOverviewData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 && scripOverviewData[WATCHLIST_GRID_INDEX.DONT_MISS] !== '0') || dontMissDataChip?.length ? 'auto' : 12} className={`d-flex ${!holdingInfo?.length ? '' : holdingInfo[2] === 'color-negative' ? 'highlighter-negative-background' : 'highlighter-positive-background'}`}>
              {(currentHolding?.length && parseInt(currentHolding[0]['TOTALFREEQUANTITY']) > 0) ?
                <div className='d-flex w-100 h_45' data-testid="market-overview-holding-section">
                  <div className='d-flex align-items-center ms-2' data-testid="market-overview-holding-quantity-section">
                    <span className='icon-16 icon-dark icon-portfolio me-2' data-testid="market-overview-portfolio-icon"></span><span className='font-regular color-text font-size4 line-height-1' data-testid="market-overview-quantity-value">{currentHolding[0]['TOTALFREEQUANTITY']}</span>
                  </div>
                  {(holdingInfo?.length) ?
                    <div className='d-flex align-items-center ms-2' data-testid="market-overview-holding-info-section">
                      <div className={`font-medium font-size4 color-text line-height-1 ${holdingInfo[2]}`} data-testid="market-overview-amount-value">&#8377;{`${Number(holdingInfo[0]).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}</div>
                      <div className={`font-medium font-size4 color-text ms-1 line-height-1 ${holdingInfo[2]}`} data-testid="market-overview-percentage-value">({holdingInfo[1]})</div>
                    </div>
                    : null
                  }
                </div>
                : null
              }
            </Col>
          </Row>
        </div> : null}

      <Row className='g-0 mt-5'>
        <Col md={12}>
          <AllExchangesMarketDepth scripOverviewData={scripOverviewData} expandScripOverviewModel={expandScripOverviewModel} heading={true} data-testid="market-overview-market-depth-section" />
        </Col>
      </Row>

      <Row className='g-0 mt-5'>
        <Col md={12}>
          <KeyStats isVertical={true} data-testid="market-overview-key-stats-section" />
        </Col>
      </Row>

      <Row className='g-0 mt-5'>
        <Col md={6} className='pe-3'>
          <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.SCRIP_OVERVIEW} data-testid="market-overview-support-resistance-section" />
        </Col>
        <Col md={6} className='ps-3'>
          <SimpleMovingAverages data-testid="market-overview-moving-averages-section" />
        </Col>
      </Row>

      <Row className='g-0 mt-5'>
        <Col md={6} className='pe-3'>
          <DeliveryQuantityBuildup data-testid="market-overview-delivery-buildup-section" />
        </Col>
        <Col md={6} className='ps-3'>
          <MarketPulse data-testid="market-overview-pulse-section" />
        </Col>
      </Row>

      <Row className='g-0 mt-5'>
        <Col>
          <MarketMovement setIsMarketMovement={setIsMarketMovement} data-testid="market-overview-movement-section" />
        </Col>
      </Row>
    </Container>
  );
};

export default memo(Overview);
